export class RoleUsers {
  public roleID: number;
  public userID: number;
}

